import type { Product } from '../../../types/product-card';

export const getProductCardDetails = (article: Product) => {
  const showVariants = Boolean(article.variations);
  const showDelivery = Boolean(article.delivery?.flags?.fastDelivery);

  return { showVariants, showDelivery };
};
